import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SecondaryButtonLink } from "../../../../components/Buttons";
import { PermissionResource, Resources } from "../../../Permissions";

const mapStateToProps = (state) => ({
  adConnections: state.task.adConnections,
  anpConnections: state.task.anpConnections,
  adWorkplaceTasks: state.task.adWorkplaceTasks,
  ptConnections: state.task.ptConnections,
  delphiConnections: state.task.delphiConnections,
  msAuthenticatorTasks: state.task.msAuthenticatorTasks,
  jarvisConnections: state.task.jarvisConnections,
});

const renderItem = (label, value) => {
  const labelClassName = value > 0 ? "w3-text-green" : "";
  return (
    <li className="no-pad-tb">
      <span className={`w3-right ${labelClassName}`}>{value || "Keine"}</span>
      <span>{label}</span>
    </li>
  );
};

const TaskDashboard = ({
  className = "",
  holderClassName = null,
  showTotal = false,
  adConnections,
  anpConnections,
  adWorkplaceTasks,
  ptConnections,
  delphiConnections,
  msAuthenticatorTasks,
  jarvisConnections,
}) => {
  // console.log("ITTaskDashboard.render()", props);
  const total =
    adConnections.length +
    anpConnections.length +
    adWorkplaceTasks.length +
    ptConnections.length +
    delphiConnections.length +
    msAuthenticatorTasks.length +
    jarvisConnections.length;
  const totalLabelClassName = total > 0 ? "w3-text-green" : "";

  const content = (
    <SecondaryButtonLink
      id="itConnectionTasks"
      className={className}
      to="/aufgaben/it-zugaenge"
      style={{ minHeight: "384px" }}
    >
      <h3 className="no-margin alg-center pad-big-top ">IT-Zugänge</h3>
      {showTotal && (
        <div
          className={`pad-top w3-xlarge ${totalLabelClassName} alg-center pad-big-btm w3-border-bottom margin-big-btm`}
          style={{ marginLeft: "-14px", marginRight: "-14px" }}
        >
          {total > 0 ? total : "Keine"}
        </div>
      )}
      <ul className="w3-ul pad-big-btm">
        <PermissionResource
          resource={Resources.Tasks.ITConnections.ADConnections}
        >
          {renderItem("Vodafone Account", adConnections.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.ANPConnections}
        >
          {renderItem("AN-Portal Zugang", anpConnections.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.ADWorkplaceTasks}
        >
          {renderItem("VBG - CSC Kennung", adWorkplaceTasks.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.MSAuthenticator}
        >
          {renderItem("MS Authenticator", msAuthenticatorTasks.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.PTConnections}
        >
          {renderItem("iProv-Tool", ptConnections.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.DelphiConnections}
        >
          {renderItem("Delphi Zugang", delphiConnections.length)}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.ITConnections.JarvisConnections}
        >
          {renderItem("Jarvis Zugang", jarvisConnections.length)}
        </PermissionResource>
      </ul>
    </SecondaryButtonLink>
  );

  return holderClassName ? <div className={holderClassName}>{content}</div> : content;
};

TaskDashboard.propTypes = {
  className: PropTypes.string,
  holderClassName: PropTypes.string,
  showTotal: PropTypes.bool,
  adConnections: PropTypes.array,
  anpConnections: PropTypes.array,
  adWorkplaceTasks: PropTypes.array,
  ptConnections: PropTypes.array,
  delphiConnections: PropTypes.array,
  msAuthenticatorTasks: PropTypes.array,
  jarvisConnections: PropTypes.array,
};

export default connect(mapStateToProps)(TaskDashboard);
